import { saveFile } from './fileExport';

export interface CsvColumn<T> {
  header: string;
  get: (row: T) => string | number | boolean | null | undefined | Date;
}

function escapeCell(value: string | number | boolean | null | undefined | Date): string {
  if (value === null || value === undefined) return '';
  const str = value instanceof Date ? value.toISOString() : String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function rowsToCsv<T>(rows: T[], columns: CsvColumn<T>[]): string {
  const headerRow = columns.map((c) => escapeCell(c.header)).join(',');
  const dataRows = rows.map((r) => columns.map((c) => escapeCell(c.get(r))).join(','));
  return [headerRow, ...dataRows].join('\r\n');
}

export function downloadCsv(filename: string, csv: string): void {
  const name = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  // Leading BOM so Excel reads UTF-8 correctly.
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  // saveFile branches web (anchor download) vs native (Filesystem + Share).
  void saveFile(name, blob, 'text/csv;charset=utf-8;');
}

export function todayStamp(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
